import { render } from "./404.vue?vue&type=template&id=5f98f4f9"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"
script.render = render

export default script